module.exports = __webpack_public_path__ + "img/8market4-u.f0f2e31f.jpg";